import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { usePartnerEncumbrances } from './context/PartnerEncumbrancesContext';
import PartnerEncumbrancesBody from './components/PartnerEncumbrancesBody';
import PartnerEncumbrancesHeader from './components/PartnerencumbrancesHeader';

type PartnerEncumbrancesProps = {
  compact?: boolean;
};

const PartnerEncumbrances: FC<PartnerEncumbrancesProps> = ({
  compact = false,
}) => {
  const { data } = usePartnerEncumbrances();
  return (
    <>
      <PartnerEncumbrancesHeader />
      <PartnerEncumbrancesBody compact={compact} />

      {data.isLoading && <CustomLoading />}
    </>
  );
};
export default PartnerEncumbrances;
